import React from 'react';
import Loadable from 'react-loadable';

import FirstLoader from '../FirstLoader/FirstLoader';

const LoadableTransactionHistoryWizard = Loadable({
  loader: () => import(/* webpackChunkName: "TransactionHistory" */ './TransactionHistoryWizard'),
  modules: ['./TransactionHistory'],
  loading: () => <FirstLoader />
});

export default LoadableTransactionHistoryWizard;
